import { h } from 'preact';
import { accessNested, asList } from 'utils/utils';
import Store from 'store/store';
import * as actions from 'store/actions';

// VARIABLES //

let staticRender;
let tagIds;
let timer = Date.now();
let storeListeners = {};


// STORE LISTENERS - NETFLIX TRACKING //

storeListeners[actions.PAGE_STATE_LOADED] = () => {
	// set up Powster tracking
	let powsterCustomGA = accessNested(Store.get(), 'appData.apis.tracking.powsterGATracking');
	if (powsterCustomGA) {
		tagIds = asList(powsterCustomGA).filter(id => id.startsWith('UA-'));
	}

	if (typeof window.gtag !== 'function') {
		return;
	}

	// Netflix-specific page load event
	if (document.readyState === 'complete') {
		fireNetflixGtagLoad();
	} else {
		window.addEventListener('load', fireNetflixGtagLoad);
	}

	// Netflix-specific bounce rate event
	window.setTimeout(() => {
		gtag('event', 'adjusted bounce rate', { event_label: '8 seconds' });
	}, 8000);
};

storeListeners[actions.API_ERROR] = (api, error) => {
	// Netflix - specific API error event
	if (typeof window.gtag !== 'function') {
		return;
	}

	window.gtag('event', 'exception', {
		description: api + ' - ' + error,
		fatal: false
	});
};

// STORE LISTENERS - POWSTER CREATIVE TRACKING //

storeListeners[actions.NETFLIX_BUTTON_CLICK] = (section, title, destination) => {
	const activePage = accessNested(Store.get(), 'activePage.id');
	const label = title + '_' + destination;

	firePowsterCustomEvent(section, activePage, label);
}

storeListeners[actions.NETFLIX_GALLERY_ITEM_CLICK] = (section, title, filename) => {
	const activePage = accessNested(Store.get(), 'activePage.id');
	const label = title ? (title + '_' + filename.split('/').pop()) : filename.split('/').pop();

	firePowsterCustomEvent(section, activePage, label);
}

storeListeners[actions.NETFLIX_GALLERY_ITEM_LINK_CLICK] = ({ title, href }) => {
	const activePage = accessNested(Store.get(), 'activePage.id');
	const label = title || href;

	firePowsterCustomEvent('gallery-link-click', activePage, label);
};

storeListeners[actions.NETFLIX_RESOURCE_CLICK] = (section, title, name, destination) => {
	if (destination) {
		const activePage = accessNested(Store.get(), 'activePage.id');
		const label = (title ? title + '_' : '') + name + '_' + destination;

		firePowsterCustomEvent(section, activePage, label);
	}
}

// TRACKING FUNCIONS //

function fireNetflixGtagLoad() {
	const loaded = Date.now();
	const loadTime = loaded - timer;

	gtag('event', 'timing_complete', {
		'name' : 'load',
		'value' : loadTime,
		'event_category' : 'pageLoad'
	});
}

function firePowsterCustomEvent(action, category, label, options) {
	if (typeof powsterGtag !== 'function') {
		return;
	}
	if (!tagIds) return;

	const region = accessNested(Store.get(), 'appData.meta.region.slug');

	const args = {
		event_category: category,
		event_label: label,
		send_to: tagIds,
		region: region
	};

	Object.assign(args, options);

	window.powsterGtag('event', action, args);
}

function firePowsterGtagPageView(pageId) {
	if (typeof powsterGtag !== 'function') {
		return;
	}

	if (!tagIds) return;

	const region = accessNested(Store.get(), 'appData.meta.region.slug');

	let path = pageId;

	tagIds.forEach(tagId => {
		window.powsterGtag('config', tagId, {
			page_title: pageId,
			page_path: path,
			anonymize_ip: 'true',
			custom_map: {
				'dimension1': 'region'
			},
			'region': region
		});
	});
}

export {
	staticRender,
	storeListeners
};
